export default "__VITE_ASSET__BErb7DLr__"